import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

// Card and payment details older builds kept in the browser. Payments are
// now confirmed server-side, so nothing reads these; clear them once.
try {
  ['PATHIQ_STRIPE_PAYMENT_METHOD', 'PATHIQ_LAST_CAMPAIGN_PAYMENT'].forEach(
    (key) => window.localStorage.removeItem(key)
  );
} catch {
  // Storage can be unavailable (private mode, blocked site data).
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
